import { Controller } from "@hotwired/stimulus"

// Flips the dot to offline client-side once its known online window elapses.
// The server only broadcasts on activity (subscribe/ping), never on "went
// quiet" — without this, a reader who stopped pinging (closed the tab,
// lost network) would look online forever until someone else's action
// happened to re-render the page.
export default class extends Controller {
  static targets = ["dot", "label"]
  static values = { onlineUntil: String, offlineText: String }

  connect() {
    this.scheduleOfflineFlip()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  scheduleOfflineFlip() {
    if (!this.hasDotTarget || !this.onlineUntilValue) return

    const msRemaining = new Date(this.onlineUntilValue).getTime() - Date.now()
    if (msRemaining <= 0) {
      this.markOffline()
    } else {
      this.timeout = setTimeout(() => this.markOffline(), msRemaining)
    }
  }

  markOffline() {
    this.dotTarget.classList.remove("bg-success")
    this.dotTarget.classList.add("bg-base-content/25")
    if (this.hasLabelTarget) this.labelTarget.textContent = this.offlineTextValue
  }
}
